/*******************************************************************************
 * PaymentItem */
/**
 * @ngdoc   run
 * @module  csm.books.com.returnItems
 * @name    csm.books.com.returnItems.run:PaymentItem
 * @description
 * Creates a data object constructor for the list of available payments.
 *******************************************************************************/
/* @ngInject */ export function ReturnItemsRunPaymentItem(Data, SERVER) {
  /*****************************************************************************
   * Constructor
   *****************************************************************************/
  Data.PaymentItem = function (payment) {
    var p = Object.assign(
      Object.create(Data.PaymentItem.prototype),
      payment || {}
    );

    return p;
  };

  /*****************************************************************************
   * Prototype
   *****************************************************************************/
  Data.PaymentItem.prototype = {
    id: NaN,
    number: null,
    name: null,
    amount: NaN,
    refunded: NaN,
    accountID: NaN,
    processorType: NaN,
    subType: NaN,

    /*-----------------------------*/
    /* Display field for the type. */
    /*-----------------------------*/
    set typeName(readOnly) {},
    get typeName() {
      switch (this.subType) {
        case SERVER.BooksDBConstants.LIS_CHECK_RECEIVED:
          return 'Check';
        case SERVER.BooksDBConstants.LIS_CREDIT_CARD:
        case SERVER.BooksDBConstants.LIS_DEBIT_CARD:
        case SERVER.BooksDBConstants.LIS_WEBSTORE:
          return 'Card';
        default:
          return 'Unknown';
      }
    }
  };
}
